
import PageLayout from "components/layout/PageLayout"
import { useRegisterNewEmployeeMutation } from "./api/employmentApiSlice"
import { useGetCompanyRolesQuery } from "../companyRoles/api/companyRolesApiSlice"
import { useSaveWorkerContractMutation } from "../../hr/workContract/api/workContractApiSlice"
import { useTranslation } from "react-i18next"
import EmploymentForm from "./components/EmploymentForm"

const NewEmployment = () => {
  const [t] = useTranslation(["global"])
  const [registerEmployee, { data, isLoading, isSuccess, reset: resetCreate }] = useRegisterNewEmployeeMutation()
  const { data: roles, isFetching: loadingRoles } = useGetCompanyRolesQuery()
  const [saveContract] = useSaveWorkerContractMutation()

  const handleSubmit = async (formData) => {
    const { workContract, isEmployee, ...userPayload } = formData
    const res = await registerEmployee(userPayload).unwrap()
    if (isEmployee && res?.user?.guid) {
      await saveContract({
        userGuid: res.user.guid,
        week: workContract.week,
        employmentDate: workContract.employmentDate,
        workerClassGuid: workContract.workerClass.guid
      }).unwrap()
    }
  }

  return (
    <PageLayout
      pageTitle={t("menu.new_employment")}
      isLoadingPage={loadingRoles}
      isLoadingContent={isLoading}
      bodyContent={
        isSuccess ? (
          <>
            <p><b>{data.user.displayName}</b> {t("helper.employee_creation_success")}</p>
            <button className="btn btn-primary" onClick={resetCreate}>
              <i className="fa-solid fa-user-plus"></i> {t("action.add_another")}
            </button>
          </>
        ) : (
          roles && (
            <EmploymentForm
              mode="create"
              roles={roles}
              onSubmit={handleSubmit}
              isLoading={isLoading}
              t={t}
            />
          )
        )
      }
    />
  )
}

export default NewEmployment
